import { Grid, Hidden } from "@material-ui/core";
import React from "react";

type columnCount = boolean | "auto" | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | undefined;

interface FormGridCellProps {
  children?: JSX.Element;
  size?: "small" | "medium" | "half" | "full" | "fill" | "third" | "fourth" | "sixth" | "wide";
  className?: string;
}

const FormGridCell: React.FC<FormGridCellProps> = (props) => {
  const { children, className, size } = props;
  let xs: columnCount, sm: columnCount, md: columnCount, lg: columnCount, xl: columnCount;

  if (size === "small") {
    xs = 4;
    md = 3;
    lg = 2;
    xl = 1;
  } else if (size === "half") {
    xs = 12;
    md = 4;
    lg = 3;
    xl = 2;
  } else if (size === "medium") {
    xs = 8;
    md = 5;
    lg = 4;
    xl = 3;
  } else if (size === "full") {
    xs = 12;
    md = 8;
    lg = 6;
    xl = 4;
  } else if (size === "fill") {
    xs = 12;
    md = 4;
    lg = 6;
    xl = 8;
  } else if (size === "third") {
    xs = 12;
    sm = 6;
    md = 4;
    lg = 4;
    xl = 4;
  } else if (size === "fourth") {
    xs = 12;
    sm = 6;
    md = 3;
    lg = 3;
    xl = 3;
  } else if (size === "sixth") {
    xs = 12;
    sm = 6;
    md = 2;
    lg = 2;
    xl = 2;
  } else if (size === "wide") {
    xs = 12;
    sm = 12;
    md = 12;
    lg = 12;
    xl = 12;
  }

  const grid = (
    <Grid className={className} item={true} xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
      {children}
    </Grid>
  );
  return children ? grid : <Hidden only={"xs"}>{grid}</Hidden>;
};

FormGridCell.defaultProps = {
  size: "medium",
} as Partial<FormGridCellProps>;

export default FormGridCell;
